import { unwrapResult } from "@reduxjs/toolkit";
import axios from "axios";
import ExcelJS from "exceljs";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import * as XLSX from "xlsx";
import DownloadIcon from "../../../../assets/Icons/DownloadIcon";
import DropdownArrowIcon from "../../../../assets/Icons/DropdownArrowIcon";
import NoDataFoundIcon from "../../../../assets/Icons/NoDataFoundIcon";
import PreviewIcon from "../../../../assets/Icons/PreviewIcon";
import UploadIcon from "../../../../assets/Icons/UploadIcon";
import ExCheckBox from "../../../../components/basic-components/ExCheckBox";
import ExInput from "../../../../components/basic-components/ExInput";
import ExMultiDropdown from "../../../../components/basic-components/ExMultiDropdown";
import Popup from "../../../../components/popup/Popup";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import * as constants from "../../../../constant";
import {
  getMappedCandidatesAPi,
  getMappedCandidateUsersApi,
} from "../../../../slices/aiSlice";
import useIndustries from "../../../../utils/dropdown-options/useIndustries";
import useLocations from "../../../../utils/dropdown-options/useLocations";
import useSubIndustries from "../../../../utils/dropdown-options/useSubIndustries";

const GlobalSearch = () => {
  const dispatch = useAppDispatch();

  const { jobId } = useParams();

  const { globalSearch } = useAppSelector((state) => state.ai);

  const { defaultIndustries } = useIndustries();

  const { error, isLoading, mappedCandidates } = globalSearch;
  console.log(mappedCandidates, "mappedCandidatesmappedCandidates");
  //const industriesArray = useAppSelector((state) => state.appConfig.industries);

  const btnRef = useRef(null);
  const user = useAppSelector((state) => state.company.memberDetails);

  const [selectedFilter, setSelectedFilter] = useState("history");

  const { locationsArray } = useLocations();
  const { industriesArray } = useIndustries();
  const { subIndustries } = useSubIndustries();
  const token = useAppSelector((state) => state?.login?.session?.token);
  const companyListRef = useRef(null);
  const jdRef = useRef(null);

  const form = useForm({
    defaultValues: {
      jobTitle: "",
      specificCompany: [],
      location: [],
      industry: [],
      subIndustry: [],
      iterations: 2,
      clientCompany: "",
      addPrompt: "",
      company_No: null,
    },
  });

  const { handleSubmit, control, formState, setValue } = form;
  const { errors } = formState;

  useEffect(() => {
    dispatch(
      getMappedCandidateUsersApi({
        authorId: user?.id,
        searchId: selectedFilter,
        companyId: "",
      })
    );
  }, [selectedFilter]);

  // useEffect(() => {
  //   const getJobDetails = async () => {
  //     const toasId = toast.loading("Retrieving job data.");
  //     try {
  //       const response = await dispatch(getJobDetailApi({ jobId })).then(
  //         unwrapResult
  //       );
  //       const data = response.data.data[0];

  //       const industries =
  //         data?.industries && data?.industries.length > 0
  //           ? defaultIndustries(data?.industries)
  //           : [];

  //       const globalSearchData = {
  //         industry: industries && industries.length > 0 ? industries : [],
  //         jobTitle: data?.title,
  //         sub_industry: null,
  //         iterations: 1,
  //         Master_Excel_Path: null,
  //       };
  //       //globalSearchHandler(globalSearchData);
  //       toast.dismiss(toasId);
  //     } catch (error) {
  //       toast.dismiss(toasId);
  //       toast.error("Unable to fetch job details");
  //     }
  //   };

  //   if (jobId) {
  //     getJobDetails();
  //   }
  // }, []);

  const globalSearchHandler = async (formData) => {
    const resultString = formData?.industry?.map((obj) => obj.Name);
    const locations = formData?.locations?.map((obj) => obj.Title);
    //console.log(formData.locations);
    const toastId = toast.loading("Fetching data...");
    try {
      const response = await dispatch(
        getMappedCandidatesAPi({
          industry: resultString,
          title: formData?.jobTitle,
          subIndustry: null,
          iterations: 2,
          Master_Excel_Path: null,
          addPrompt: formData.addPrompt,
          location: locations,
          clientCompany: formData.clientCompany,
          company_No: parseInt(formData.company_No),
          companyId: user?.companyId,
          jobDetails: "",
          jobId: "",
          specificCompany: formData.specificCompany,
        })
      ).then(unwrapResult);
      toast.dismiss(toastId);
      if (response.count === 0) toast.error("Candidates not found");
      else {
        toast.success("Candidates fetched successfully");
        setShow(false);
        // getUserslist();
        setSelectedFilter("latest");
      }
    } catch (error) {
      toast.dismiss(toastId);
      //toast.error("Something went wrong!");
    }
  };

  // const getUserslist = () => {
  //   dispatch(
  //     getMappedCandidateUsersApi({
  //       searchId: "latest",
  //       authorId: user.id,
  //     })
  //   );
  // };

  const onSubmit = (formData) => {
    globalSearchHandler(formData);
  };

  const submitFormhandler = () => {
    //if (btnRef.current) btnRef.current.click();
  };

  const textareaRef = useRef(null);

  const handleInput = () => {
    const textarea = textareaRef.current;
    textarea.style.height = "auto"; // Reset height
    textarea.style.height = `${textarea.scrollHeight}px`; // Set to scroll height
  };

  const [show, setShow] = useState(true);

  const [companyNo, specificCompany] = useWatch({
    control,
    name: ["company_No", "specificCompany"],
  });

  const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);

  const handleCheckedClick = () => {
    if (selectedCandidateIds.length > 0) {
      setSelectedCandidateIds([]);
    } else {
      let selectedIds = mappedCandidates.map((can) => can.id);
      setSelectedCandidateIds([...selectedIds]);
    }
  };

  const handleSingleCheckBoxClick = (id) => {
    var candidateIds = selectedCandidateIds;
    if (selectedCandidateIds.includes(id)) {
      candidateIds = candidateIds.filter((Id) => id != Id);
      setSelectedCandidateIds([...candidateIds]);
    } else {
      candidateIds.push(id);
      setSelectedCandidateIds([...candidateIds]);
    }
  };

  const [togglePopup, setTogglePopup] = useState(false);
  const [preview, setPreviewImages] = useState([]);

  const togglePopupHandler = (attachment) => {
    console.log(attachment, "attachmentattachment");
    setPreviewImages(attachment);
    setTogglePopup(!togglePopup);
  };

  // const downloadMultipleFiles = () => {
  //   mappedCandidates.forEach((candidate, index) => {
  //     const link = document.createElement("a");
  //     link.href = `${constants.baseUrl}/${candidate.actual.Actual}?t=${token}`;
  //     link.download = `${candidate.firstName}_${candidate.lastName}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   });
  // };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // const downloadMultipleFiles = async () => {
  //   // for (let i = 0; i < mappedCandidates.length; i++) {
  //   //   const url = mappedCandidates[i].actual.Actual;
  //   //   try {
  //   //     const response = await axios.get(
  //   //       `${constants.baseUrl}/${url}?t=${token}`,
  //   //       {
  //   //         responseType: "blob",
  //   //         // headers: { Authorization: `Bearer ${token}` }, // if needed
  //   //       }
  //   //     );
  //   //     const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  //   //     const link = document.createElement("a");
  //   //     link.href = blobUrl;
  //   //     link.setAttribute(
  //   //       "download",
  //   //       `${mappedCandidates[i].firstName}_${mappedCandidates[i].lastName}.pdf`
  //   //     );
  //   //     document.body.appendChild(link);
  //   //     link.click();
  //   //     document.body.removeChild(link);
  //   //     window.URL.revokeObjectURL(blobUrl);
  //   //     await sleep(1000); // wait 1 second between downloads
  //   //   } catch (error) {
  //   //     console.error(`Failed to download file ${i + 1}:`, error);
  //   //   }
  //   // }
  // };

  const downloadMultipleFiles = async () => {
    let exportList = mappedCandidates.filter((can) =>
      selectedCandidateIds.includes(can.id)
    );
    const workbook = new ExcelJS.Workbook();
    // Add a worksheet
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.columns = [
      { header: "Sr.No", key: "Sr.No", width: 20 },
      { header: "Candidate Name", key: "Candidate Name", width: 20 },
      { header: "Current Designation", key: "Current Designation", width: 20 },
      { header: "Current Company", key: "Current Company", width: 20 },
      { header: "LinkedIn ID", key: "LinkedIn ID", width: 20 },
      {
        header: "Professional Summary",
        key: "Professional Summary",
        width: 20,
      },
      { header: "Industry", key: "Industry", width: 20 },
      { header: "Relevant Experience", key: "Relevant Experience", width: 20 },
      { header: "Location", key: "Location", width: 20 },
      { header: "Skills", key: "Skills", width: 20 },
      { header: "Education", key: "Education", width: 20 },
      { header: "Date/Time", key: "Date/Time", width: 20 },
    ];
    // Apply bold to the header row
    worksheet.getRow(1).font = { bold: true, size: 12 };

    exportList.forEach((item, i) => {
      const customizedData = [
        i + 1,
        `${item.firstName}  ${item.lastName}`, // Example: Capitalize name
        item.title,
        item.currentCompany,
        item.linkedinID,
        item.professionalSummary,
        item.industry.map((ind) => ind).join(","),
        item.experience,
        item.location,
        item.skills,
        item.education,
        `${moment(item.createdAt).format("DD/MM/YYYY")}/
                    ${moment(item.createdAt).format("LT")}`,
      ];
      const row = worksheet.addRow(customizedData);

      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
        cell.alignment = { horizontal: "left" };
      });
    });

    // Save the file as a blob and download it
    workbook.xlsx.writeBuffer().then((buffer) => {
      const data = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(data);
      link.download = `Exported_candidate_mapping_list.xlsx`;
      link.click();
    });
  };

  const singleDownloadFiles = async (url, name) => {
    try {
      const response = await axios.get(
        `${constants.baseUrl}/${url}?t=${token}`,
        {
          responseType: "blob",
        }
      );

      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `${name}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error(`Failed to download file`, error);
    }
  };

  // const handleChange = (e) => {};
  const [companyList, setCompanyList] = useState([]);

  const companyListUpload = (event) => {
    //const fileUploaded = event.target.files[0];
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const workbook = XLSX.read(bstr, { type: "binary" });

      // Assume the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert to JSON
      let data = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      data = data.map((row) => row.Company_Name);
      let companyList = data.map((item) => item).join(",");

      console.log(companyList, "companyListcompanyList");

      setValue("specificCompany", companyList);
    };
    reader.readAsBinaryString(file);
  };
  const jdUpload = (event) => {
    const fileUploaded = event.target.files[0];
    const formData = new FormData();
    // formData.append(
    //   "file",
    //   `${constants.baseUrl}/${response[0].url}?t=${loginSelector.token}`
    // );
    // dispatch(getJdDetailsApi({ file: fileUploaded }));
  };

  return (
    <div className="space-y-2">
      <div className="p-4 space-y-4" style={{}}>
        <div
          className="flex items-center justify-center"
          onClick={() => setShow(!show)}
        >
          <h1 className="text-xl text-exgray-500 font-semibold items-center underline">
            Candidate Mapping
          </h1>
          <div
            className={`ml-5 transition-transform duration-300 ${
              show ? "rotate-180" : ""
            }`}
          >
            <DropdownArrowIcon color="#000000" />
          </div>

          {/* <div className="flex items-center justify-between gap-2">
            <button className="border border-exwhite-100 rounded-sm px-6 py-2 text-center text-base font-semibold text-exwhite-100 bg-[#3996E266] hover:bg-[#338AD1]">
              + Upload JD
            </button>

            <button
              className="border border-exwhite-100 rounded-sm px-12 py-2 text-center text-base font-semibold text-exwhite-100 bg-[#338AD1] hover:bg-[#FEEE91] hover:text-exgray-700 hover:border-[#FEEE91]"
              onClick={submitFormhandler}
            >
              Search
            </button>
          </div> */}
        </div>

        {show && (
          <form className="space-y-2" onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Controller
                  name="clientCompany"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Hiring company is required",
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="space-y-1">
                      <div>
                        <ExInput
                          id={"clientCompany"}
                          autoComplete="off"
                          placeholder="exotalent..etc"
                          onChange={onChange}
                          value={value || ""}
                          title={"Hiring Company"}
                          isMandatory={true}
                        />
                      </div>
                      {errors?.clientCompany?.message && (
                        <p className="text-red-400">
                          {errors?.clientCompany?.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
              <div>
                <Controller
                  name="jobTitle"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Job Title is required",
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="flex items-center space-x-2">
                      <div className="space-y-1 w-11/12">
                        <div>
                          <ExInput
                            id={"jobTitle"}
                            autoComplete="off"
                            placeholder="Job Title, keyword ... *"
                            onChange={onChange}
                            value={value || ""}
                            title={"Job Title"}
                            isMandatory={true}
                          />
                        </div>
                        {errors?.jobTitle?.message && (
                          <p className="text-red-400">
                            {errors?.jobTitle?.message}
                          </p>
                        )}
                      </div>
                      <div
                        onClick={() => jdRef.current.click()}
                        className="w-1/12 flex items-center justify-center mt-5"
                      >
                        <UploadIcon color="#095BB8" width="30" height="30" />
                      </div>
                    </div>
                  )}
                />
                <input
                  type="file"
                  onChange={(event) => jdUpload(event)}
                  ref={companyListRef}
                  style={{ display: "none" }} // Make the file input element invisible
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="flex items-center">
                <Controller
                  name="company_No"
                  control={control}
                  rules={{
                    required: !specificCompany
                      ? {
                          value: true,
                          message: "Company number required field",
                        }
                      : false,
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="space-y-1 w-11/12">
                      <div>
                        <ExInput
                          id={"company_No"}
                          autoComplete="off"
                          placeholder=""
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d*$/.test(val)) {
                              setValue("company_No", val); // only set if numeric
                            }
                          }}
                          //onChange={onChange}
                          value={value || ""}
                          title={"No. of Companies * (1-150)"}
                          inputMode="numeric"
                        />
                      </div>
                      {errors?.company_No?.message && (
                        <p className="text-red-400">
                          {errors?.company_No?.message}
                        </p>
                      )}
                    </div>
                  )}
                />
                <h1 className="text-exgray-600 mx-2 mt-6">OR</h1>
              </div>

              <div>
                <Controller
                  name="specificCompany"
                  control={control}
                  rules={{
                    required: !companyNo
                      ? {
                          value: true,
                          message:
                            "Target Company is required if Company No is not filled",
                        }
                      : false,
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="flex items-center space-x-2">
                      <div className="space-y-1 w-9/12">
                        <div>
                          <ExInput
                            id={"specificCompany"}
                            autoComplete="off"
                            placeholder=""
                            onChange={onChange}
                            value={value || companyList}
                            title={"Target Companies"}
                            isMandatory={true}
                            disabled={companyNo ? true : false}
                          />
                        </div>
                        {errors?.specificCompany?.message && (
                          <p className="text-red-400">
                            {errors?.specificCompany?.message}
                          </p>
                        )}
                      </div>
                      <div
                        onClick={() => companyListRef.current.click()}
                        className="w-1/12 flex items-center justify-center mt-5"
                      >
                        <UploadIcon color="#095BB8" width="30" height="30" />
                      </div>
                      <a
                        href="https://stagebucket.blob.core.windows.net/linkcxo/www.linkcxo.com/www.linkcxo.com/Company.xlsx"
                        className=" flex items-center justify-center mt-5"
                      >
                        <h1 className="text-xs mr-1 ml-2 text-secondary-500 underline">
                          (sample_File)
                        </h1>
                        <DownloadIcon width="18" height="18" />
                      </a>
                    </div>
                  )}
                />
                <input
                  type="file"
                  onChange={(event) => companyListUpload(event)}
                  ref={companyListRef}
                  style={{ display: "none" }} // Make the file input element invisible
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Controller
                  name="industry"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Industries is required",
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="space-y-1">
                      <div>
                        {/* <ExMultiDropdown
                          title="Target Industries * (Multiple Selection)"
                          placeholder="Select"
                          onChange={onChange}
                          value={value || null}
                          optionValue="Id"
                          optionLabel="Name"
                          options={industriesArray}
                          dropDownHeight="40px"
                          dropDownBorderWidth="1px"
                          dropDownBorderColor="#8C8C8C"
                          error={errors?.departments?.message}
                        /> */}
                        <ExMultiDropdown
                          title="Industry"
                          onChange={onChange}
                          placeholder="Select"
                          value={value || null}
                          optionValue="Id"
                          optionLabel="Name"
                          options={industriesArray}
                          closeMenuOnSelect={false}
                          isMandatory={true}
                          dropDownHeight="auto"
                          dropDownBorderWidth="2px"
                          dropDownBorderColor="#CDCED2"
                          menuListHeight="250px"
                          error={errors?.industry?.message}
                        />
                      </div>
                      {errors?.industry?.message && (
                        <p className="text-red-400">
                          {errors?.industry?.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
              <div>
                <Controller
                  name="subIndustry"
                  control={control}
                  rules={{
                    required: {
                      value: false,
                      message: "SubIndustries is required",
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="space-y-1">
                      <div>
                        <ExMultiDropdown
                          title="Target Sub Industries (Multiple Selection)"
                          placeholder="Select"
                          onChange={onChange}
                          value={value || null}
                          optionValue="Id"
                          optionLabel="Title"
                          closeMenuOnSelect={false}
                          options={subIndustries}
                          dropDownHeight="auto"
                          dropDownBorderWidth="1px"
                          dropDownBorderColor="#8C8C8C"
                          error={errors?.departments?.message}
                        />
                      </div>
                      {errors?.subIndustry?.message && (
                        <p className="text-red-400">
                          {errors?.subIndustry?.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Controller
                  name="addPrompt"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Promt is required",
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="space-y-1">
                      <label
                        htmlFor={"promt"}
                        className={`text-exgray-200/70 text-base font-semibold`}
                      >
                        Prompt *
                      </label>
                      <div>
                        <textarea
                          id="addPrompt"
                          className="border border-exgray-300 rounded-md"
                          ref={textareaRef}
                          onChange={onChange}
                          onInput={handleInput}
                          placeholder="Type something..."
                          rows={1}
                          style={{
                            width: "100%",
                            resize: "none",
                            overflow: "hidden",
                            lineHeight: "1.5em",
                            padding: "8px",
                          }}
                        />
                        <h1 className="text-exgray-300 text-xs">
                          * Provide additional specifications/ requirements for
                          better and accurate result.
                        </h1>
                      </div>
                      {errors?.addPrompt?.message && (
                        <p className="text-red-400">
                          {errors?.addPrompt?.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
              <div>
                <Controller
                  name="locations"
                  control={control}
                  rules={{
                    required: {
                      value: false,
                      message: "Job Title is required",
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <div className="space-y-1">
                      <div>
                        <ExMultiDropdown
                          title="Locations(Multiple Selection)"
                          placeholder="Select"
                          onChange={onChange}
                          value={value || null}
                          optionValue="Id"
                          optionLabel="Name"
                          options={locationsArray}
                          dropDownHeight="auto"
                          dropDownBorderWidth="1px"
                          dropDownBorderColor="#8C8C8C"
                          error={errors?.locations?.message}
                          closeMenuOnSelect={false}
                        />
                      </div>
                      {errors?.locations?.message && (
                        <p className="text-red-400">
                          {errors?.locations?.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="flex items-center justify-center">
              <button
                type="submit"
                className="border border-exwhite-100 rounded-lg px-12 py-2 text-center text-base font-semibold text-exwhite-100 bg-secondary-400 hover:bg-secondary-500 hover:text-exwhite-100 "
              >
                Search
              </button>
            </div>
          </form>
        )}
      </div>
      <div className="flex justify-between">
        <div>
          <button
            onClick={() => setSelectedFilter("latest")}
            className={`${
              selectedFilter == "latest" ? "bg-secondary-400" : "bg-exgray-400"
            } rounded-lg text-exwhite-100 px-5 py-1 ml-2`}
          >
            Latest
          </button>
          <button
            onClick={() => setSelectedFilter("history")}
            className={`${
              selectedFilter == "history" ? "bg-secondary-400" : "bg-exgray-400"
            } rounded-lg text-exwhite-100 px-5 py-1 ml-2`}
          >
            History
          </button>
        </div>

        <button
          onClick={() => downloadMultipleFiles()}
          disabled={selectedCandidateIds.length === 0}
          className={`text-exwhite-100 ${
            selectedCandidateIds.length === 0
              ? "bg-exgray-300"
              : "bg-secondary-400"
          } px-5 py-1 rounded-md mr-5`}
        >
          Download
        </button>
      </div>

      <div className="">
        <div className="max-h-screenheight overflow-x-auto border-1 border-exgray-100 rounded-t-md">
          <table className="min-w-full bg-white">
            <thead className="sticky top-0 bg-gray-100 z-10 bg-secondary-500">
              <tr className="text-left">
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100">
                  <ExCheckBox
                    className="text-exwhite-100"
                    checked={
                      selectedCandidateIds?.length === mappedCandidates?.length
                    }
                    onChange={() => handleCheckedClick()}
                    name={undefined}
                    title={undefined}
                  />
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100">
                  S.No.
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100">
                  Preview
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                  Candidate Name
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                  Current Designation
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                  Current Company
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                  LinkedIn ID
                </th>
                <th className="border border-gray-300 px-4 py-2 text-nowrap text-sm font-semibold text-exwhite-100 text-center">
                  Professional Summary
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                  Industry
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                  Relevant Experience
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                  Location
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                  Skills
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                  Education
                </th>
                <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                  Date/Time
                </th>
                {/* <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exgray-200">
      ProfessionalSummary
    </th> */}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-300">
              {mappedCandidates?.map((candidate, i) => (
                <tr key={i + "can"} className="hover:bg-exgray-100">
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    <ExCheckBox
                      className="text-exwhite-100"
                      checked={selectedCandidateIds.includes(candidate.id)}
                      onChange={() => handleSingleCheckBoxClick(candidate.id)}
                      name={undefined}
                      title={undefined}
                    />
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    {i + 1}
                  </td>
                  <td className="px-4 py-2 text-sm ">
                    <div className="flex items-center justify-center">
                      <div
                        className="items-center"
                        onClick={() =>
                          togglePopupHandler(candidate.preview.Preview)
                        }
                      >
                        <PreviewIcon />
                      </div>
                      <div
                        onClick={() =>
                          singleDownloadFiles(
                            candidate.actual.Actual,
                            `${candidate.firstName}_${candidate.lastName}`
                          )
                        }
                        className="items-center ml-3"
                      >
                        <DownloadIcon />
                      </div>
                    </div>
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    {candidate["firstName"]} {candidate["lastName"]}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    {candidate.title}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    {candidate.currentCompany}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 max-w-lg">
                    <a
                      className="text-secondary-500"
                      target="_blank"
                      href={candidate.linkedinID}
                    >
                      {candidate.linkedinID}
                    </a>
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                    {candidate.professionalSummary}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 text-nowrap truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                    {candidate.industry}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                    {candidate.experience}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    {candidate.location}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                    {candidate.skills}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                    {candidate.education}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 text-nowrap">
                    {moment(candidate.createdAt).format("DD/MM/YYYY")}{" "}
                    {moment(candidate.createdAt).format("LT")}
                  </td>
                  {/* <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    <Tooltip text={candidate["Professional Summary"]}>
                      <div className="line-clamp-3">
                        {candidate["Professional Summary"]}
                      </div>
                    </Tooltip>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>

          {mappedCandidates && mappedCandidates.length === 0 && (
            <div className="w-full">
              <div className="mx-auto w-fit py-5">
                <div className="flex items-center justify-center">
                  <NoDataFoundIcon />
                </div>
                <div>
                  <h1 className="text-3xl text-expurple-800/50 font-semibold text-center">
                    No Data Found
                  </h1>
                  <p className="text-base text-exgray-200 font-medium text-center max-w-sm mx-auto">
                    Could not find any data from the global search. Please try
                    again.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Popup
        onClose={togglePopupHandler}
        visible={togglePopup}
        isCloseButton={false}
      >
        <div className="px-10 py-6 w-[60%] mx-auto bg-white shadow-md rounded-lg max-h-[80vh] overflow-y-auto">
          {preview?.map((att) => {
            return (
              <div>
                <img
                  src={`${constants.baseUrl}/${att}?t=${token}`}
                  alt="preview"
                  className="h-full w-full"
                />
              </div>
            );
          })}
        </div>
      </Popup>
    </div>
  );
};

export default GlobalSearch;
